//$ Auth Action Types

// Create
export const ACCOUNT_CREATION_STARTED = "ACCOUNT_CREATION_STARTED";
export const ACCOUNT_CREATION_SUCCESS = "ACCOUNT_CREATION_SUCCESS";
export const ACCOUNT_CREATION_FAILED = "ACCOUNT_CREATION_FAILED";

//account details
export const ACCOUNT_DETAILS_STARTED = "ACCOUNT_DETAILS_STARTED";
export const ACCOUNT_DETAILS_SUCCESS = "ACCOUNT_DETAILS_SUCCESSS";
export const ACCOUNT_DETAILS_FAILED = "ACCOUNT_DETAILS_FAILED";

//account total income
export const ACCOUNT_INCOME_STARTED = "ACCOUNT_INCOME_STARTED";
export const ACCOUNT_INCOME_SUCCESS = "ACCOUNT_INCOME_SUCCESSS";
export const ACCOUNT_INCOME_FAILED = "ACCOUNT_INCOME_FAILED";

//account total expense
export const ACCOUNT_EXPENSE_STARTED = "ACCOUNT_EXPENSE_STARTED";
export const ACCOUNT_EXPENSE_SUCCESS = "ACCOUNT_EXPENSE_SUCCESSS";
export const ACCOUNT_EXPENSE_FAILED = "ACCOUNT_EXPENSE_FAILED";

//Fetch
export const ACCOUNT_FETCH_STARTED = "ACCOUNT_FETCH_STARTED";
export const ACCOUNT_FETCH_SUCCESS = "ACCOUNT_FETCH_SUCCESS";
export const ACCOUNT_FETCH_FAILED = "ACCOUNT_FETCH_FAILED";

//Update
export const ACCOUNT_UPDATE_STARTED = "ACCOUNT_UPDATE_STARTED";
export const ACCOUNT_UPDATE_SUCCESS = "ACCOUNT_UPDATE_SUCCESS";
export const ACCOUNT_UPDATE_FAILED = "ACCOUNT_UPDATE_FAILED";

//Delete
export const ACCOUNT_DELETE_STARTED = "ACCOUNT_DELETE_STARTED";
export const ACCOUNT_DELETE_SUCCESS = "ACCOUNT_DELETE_SUCCESS";
export const ACCOUNT_DELETE_FAILED = "ACCOUNT_DELETE_FAILED";
